/* GARD PRO FAQ — per-store, country-link JS (v11: search fixed)
   ----------------------------------------------------------------
   • Each store installs this file once with its own theme-editor
     "Default language" set to the country's language code.
   • The "language" buttons act as country navigation: clicking one
     navigates to that country's FAQ URL. No iframe, no URL params,
     no localStorage.
   • The current country is highlighted and pinned to the front via
     the CSS rule `.gp-lang.is-initial { order: -1 }`. This is set
     synchronously before any network call — no jerk, no delay.
   ---------------------------------------------------------------- */
(function () {
  'use strict';

  // ------------------------------------------------------------------
  // Country → FAQ URL map. UPDATE HERE if a store URL changes.
  // Same file is uploaded to every store.
  // Note: da, no, fi are served from gardpro.com via ?lang= because
  // those countries don't have a dedicated store domain.
  // ------------------------------------------------------------------
  var COUNTRY_URLS = {
    'en':    'https://gardpro.com/pages/gard-pro-new-faq',
    'en-gb': 'https://gardpro.co.uk/pages/gard-pro-new-faq',
    'nl':    'https://gardpro.nl/pages/gard-pro-new-faq',
    'de':    'https://gardpro.de/pages/gard-pro-new-faq',
    'fr':    'https://gardpro.fr/pages/gard-pro-new-faq',
    'it':    'https://gardpro.it/pages/gard-pro-new-faq',
    'es':    'https://gardpro.es/pages/gard-pro-new-faq',
    'sv':    'https://gardpro.se/pages/gard-pro-new-faq',
    'da':    'https://gardpro.com/pages/gard-pro-new-faq?lang=da',
    'no':    'https://gardpro.com/pages/gard-pro-new-faq?lang=no',
    'fi':    'https://gardpro.com/pages/gard-pro-new-faq?lang=fi'
  };

  var SUPPORTED_LANGS = Object.keys(COUNTRY_URLS);

  var root = document.querySelector('.gp-faq');
  if (!root) return;

  // Determine the current language:
  //   1. ?lang=XX in the URL  (the .com store uses this for da/no/fi)
  //   2. data-default-lang attribute from the theme-editor setting
  //   3. 'en' as the final fallback
  var currentLang = '';
  try {
    var qp = (new URLSearchParams(window.location.search).get('lang') || '').toLowerCase();
    if (qp && SUPPORTED_LANGS.indexOf(qp) !== -1) currentLang = qp;
  } catch (e) {}
  if (!currentLang) currentLang = root.getAttribute('data-default-lang') || 'en';
  if (SUPPORTED_LANGS.indexOf(currentLang) === -1) currentLang = 'en';

  // ------------------------------------------------------------------
  // Mark the current country as initial + active SYNCHRONOUSLY so the
  // CSS rule `.gp-lang.is-initial { order: -1 }` pins it to the front
  // before any network activity. No reorder ever happens after this.
  // ------------------------------------------------------------------
  var langBtns = root.querySelectorAll('.gp-lang');
  for (var i = 0; i < langBtns.length; i++) {
    var l = langBtns[i].getAttribute('data-lang');
    if (l === currentLang) {
      langBtns[i].classList.add('is-initial');
      langBtns[i].classList.add('is-active');
    }
    // Hide buttons for countries we don't have a URL for.
    if (!COUNTRY_URLS[l]) {
      langBtns[i].style.display = 'none';
    }
  }

  // ------------------------------------------------------------------
  // Load this store's language JSON (+ English as safety fallback).
  // ------------------------------------------------------------------
  var ASSET_URLS = window.__GP_FAQ_URLS || {};
  var bust = '?_=' + Date.now();
  var merged = {};

  function fetchLang(lang) {
    var url = ASSET_URLS[lang];
    if (!url) return Promise.resolve({});
    return fetch(url + bust, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; });
  }

  function applyLanguage() {
    var jobs = [fetchLang('en')];
    if (currentLang !== 'en') jobs.push(fetchLang(currentLang));
    return Promise.all(jobs).then(function (results) {
      for (var i = 0; i < results.length; i++) {
        var data = results[i] || {};
        for (var k in data) {
          if (Object.prototype.hasOwnProperty.call(data, k)) {
            var v = data[k];
            if (v != null && v !== '') merged[k] = v;
          }
        }
      }
      renderAll();
      document.documentElement.setAttribute('lang', currentLang);
    });
  }

  function renderAll() {
    var nodes = root.querySelectorAll('[data-faq-key]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var key = el.getAttribute('data-faq-key');
      if (!key || !(key in merged)) continue;
      var val = merged[key];
      var attr = el.getAttribute('data-faq-attr');
      var asHtml = el.getAttribute('data-faq-html') === '1';
      if (attr) {
        el.setAttribute(attr, val);
      } else if (asHtml) {
        el.innerHTML = val;
      } else {
        el.textContent = val;
      }
    }
  }

  // ------------------------------------------------------------------
  // Click handlers
  // ------------------------------------------------------------------
  root.addEventListener('click', function (e) {
    var t = e.target;

    // Country buttons → navigate to that store's FAQ page.
    var langBtn = t.closest && t.closest('.gp-lang');
    if (langBtn) {
      var l = langBtn.getAttribute('data-lang');
      if (l && l !== currentLang && COUNTRY_URLS[l]) {
        window.location.href = COUNTRY_URLS[l];
      }
      e.preventDefault();
      return;
    }

    var catBtn = t.closest && t.closest('.gp-tab');
    if (catBtn) {
      activateCategory(catBtn.getAttribute('data-cat'));
      e.preventDefault();
      return;
    }

    var serBtn = t.closest && t.closest('.gp-series');
    if (serBtn) {
      activateSeries(serBtn.getAttribute('data-series'));
      e.preventDefault();
      return;
    }

    var pBtn = t.closest && t.closest('.gp-ptab');
    if (pBtn) {
      activateProduct(pBtn.getAttribute('data-prod'));
      e.preventDefault();
      return;
    }
  });

  function setActive(nodes, predicate) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.toggle('is-active', predicate(nodes[i]));
    }
  }

  function activateCategory(cat) {
    setActive(root.querySelectorAll('.gp-tab'),
      function (n) { return n.getAttribute('data-cat') === cat; });
    setActive(root.querySelectorAll('.gp-panel'),
      function (n) { return n.getAttribute('data-cat') === cat; });
  }

  function activateSeries(ser) {
    setActive(root.querySelectorAll('.gp-series'),
      function (n) { return n.getAttribute('data-series') === ser; });
    var ptabs = root.querySelectorAll('.gp-ptab');
    var firstShown = null;
    for (var i = 0; i < ptabs.length; i++) {
      var match = ptabs[i].getAttribute('data-series') === ser;
      ptabs[i].style.display = match ? '' : 'none';
      ptabs[i].classList.remove('is-active');
      if (match && !firstShown) firstShown = ptabs[i];
    }
    if (firstShown) {
      firstShown.classList.add('is-active');
      activateProduct(firstShown.getAttribute('data-prod'));
    }
  }

  function activateProduct(prod) {
    setActive(root.querySelectorAll('.gp-ptab'),
      function (n) { return n.getAttribute('data-prod') === prod; });
    setActive(root.querySelectorAll('.gp-ppanel'),
      function (n) { return n.getAttribute('data-prod') === prod; });
  }

  function initSeriesFilter() {
    var activeSeriesBtn = root.querySelector('.gp-series.is-active');
    var ser = activeSeriesBtn ? activeSeriesBtn.getAttribute('data-series') : null;
    if (!ser) {
      var firstSer = root.querySelector('.gp-series');
      if (!firstSer) return;
      ser = firstSer.getAttribute('data-series');
      firstSer.classList.add('is-active');
    }
    var ptabs = root.querySelectorAll('.gp-ptab');
    var activeProd = null;
    for (var i = 0; i < ptabs.length; i++) {
      var match = ptabs[i].getAttribute('data-series') === ser;
      ptabs[i].style.display = match ? '' : 'none';
      if (match && ptabs[i].classList.contains('is-active')) {
        activeProd = ptabs[i].getAttribute('data-prod');
      }
    }
    if (!activeProd) {
      for (var j = 0; j < ptabs.length; j++) {
        if (ptabs[j].getAttribute('data-series') === ser) {
          ptabs[j].classList.add('is-active');
          activateProduct(ptabs[j].getAttribute('data-prod'));
          break;
        }
      }
    } else {
      activateProduct(activeProd);
    }
  }

  // ------------------------------------------------------------------
  // Search (v11): searches ALL tabs, expands matching sections, hides the
  // rest, tags each section with its product/category, shows "no results".
  // Uses the existing CSS: .gp-faq.is-searching + details.gp-hidden +
  // .gp-search-tag. Clearing the box restores the normal tabbed view.
  // ------------------------------------------------------------------
  var NO_RESULTS = {
    'en': 'No results found. Try another word.', 'en-gb': 'No results found. Try another word.',
    'nl': 'Geen resultaten gevonden. Probeer een ander woord.', 'de': 'Keine Ergebnisse gefunden. Versuche ein anderes Wort.',
    'fr': 'Aucun résultat. Essayez un autre mot.', 'it': 'Nessun risultato. Prova con un’altra parola.',
    'es': 'No hay resultados. Prueba con otra palabra.', 'sv': 'Inga resultat. Prova ett annat ord.',
    'da': 'Ingen resultater. Prøv et andet ord.', 'no': 'Ingen resultater. Prøv et annet ord.', 'fi': 'Ei tuloksia. Kokeile toista sanaa.'
  };
  var searchInput = root.querySelector('.gp-search');
  var noResultsEl = null, tagsAdded = false;

  if (searchInput) {
    var debounceT;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceT);
      debounceT = setTimeout(function () { runSearch(searchInput.value); }, 150);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(debounceT); runSearch(searchInput.value); }
      if (e.key === 'Escape') { searchInput.value = ''; runSearch(''); }
    });
    searchInput.addEventListener('search', function () { runSearch(searchInput.value); }); // native "x" clear
  }

  function normalizeForSearch(s) {
    if (!s) return '';
    return s.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // Label each section with its product (watches) or category (other tabs), once, after translations.
  function addTags() {
    if (tagsAdded) return; tagsAdded = true;
    var sections = root.querySelectorAll('details.gp-section');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i], label = '';
      var pp = sec.closest('.gp-ppanel');
      if (pp) {
        var pt = root.querySelector('.gp-ptab[data-prod="' + pp.getAttribute('data-prod') + '"] span');
        label = pt ? pt.textContent.trim() : '';
      } else {
        var pn = sec.closest('.gp-panel');
        var tb = pn && root.querySelector('.gp-tab[data-cat="' + pn.getAttribute('data-cat') + '"]');
        label = tb ? tb.textContent.trim() : '';
      }
      var title = sec.querySelector('.gp-section-title');
      if (label && title && !sec.querySelector('.gp-search-tag')) {
        var tag = document.createElement('span');
        tag.className = 'gp-search-tag'; tag.textContent = label;
        title.appendChild(tag);
      }
    }
  }

  function setDisplay(nodes, fn) { for (var i = 0; i < nodes.length; i++) nodes[i].style.display = fn(nodes[i]); }

  function runSearch(raw) {
    var q = normalizeForSearch(raw);
    var searching = q.length >= 2;
    root.classList.toggle('is-searching', searching);
    var seriesTabs = root.querySelectorAll('.gp-series-tabs');
    setDisplay(seriesTabs, function () { return searching ? 'none' : ''; });

    var sections = root.querySelectorAll('details.gp-section');
    var questions = root.querySelectorAll('details:not(.gp-section)');

    if (!searching) {
      for (var i = 0; i < questions.length; i++) {
        questions[i].classList.remove('gp-hidden');
        if (questions[i].hasAttribute('data-gp-sopen')) { questions[i].open = false; questions[i].removeAttribute('data-gp-sopen'); }
      }
      for (var j = 0; j < sections.length; j++) {
        sections[j].classList.remove('gp-hidden');
        if (sections[j].hasAttribute('data-gp-sopen')) { sections[j].open = false; sections[j].removeAttribute('data-gp-sopen'); }
      }
      setDisplay(root.querySelectorAll('.gp-panel, .gp-ppanel'), function () { return ''; });
      if (noResultsEl) noResultsEl.style.display = 'none';
      return;
    }

    addTags();
    var total = 0;
    for (var s = 0; s < sections.length; s++) {
      var sec = sections[s];
      var titleEl = sec.querySelector('.gp-section-title');
      var secMatch = titleEl && normalizeForSearch(titleEl.firstChild ? titleEl.firstChild.textContent : '').indexOf(q) !== -1;
      var qs = sec.querySelectorAll('details:not(.gp-section)');
      var hits = 0;
      for (var k = 0; k < qs.length; k++) {
        var det = qs[k], sum = det.querySelector('summary');
        var aDiv = det.querySelector('[data-faq-html]');
        var m = secMatch || normalizeForSearch(sum ? sum.textContent : '').indexOf(q) !== -1 ||
                (aDiv && normalizeForSearch(aDiv.textContent).indexOf(q) !== -1);
        det.classList.toggle('gp-hidden', !m);
        if (m) { hits++; if (!secMatch && !det.open) { det.open = true; det.setAttribute('data-gp-sopen', ''); } }
      }
      sec.classList.toggle('gp-hidden', hits === 0);
      if (hits && !sec.open) { sec.open = true; sec.setAttribute('data-gp-sopen', ''); }
      total += hits;
    }
    // Hide product panels / category panels with no visible section.
    setDisplay(root.querySelectorAll('.gp-ppanel, .gp-panel'), function (n) {
      return n.querySelector('details.gp-section:not(.gp-hidden)') ? '' : 'none';
    });

    if (!noResultsEl) {
      noResultsEl = document.createElement('p');
      noResultsEl.className = 'gp-no-results';
      noResultsEl.style.cssText = 'padding:24px 0;color:#666;font-size:15px;text-align:center;';
      var tabs = root.querySelector('.gp-tabs');
      (tabs && tabs.parentNode ? tabs.parentNode : root).insertBefore(noResultsEl, tabs ? tabs.nextSibling : null);
    }
    noResultsEl.textContent = NO_RESULTS[currentLang] || NO_RESULTS.en;
    noResultsEl.style.display = total ? 'none' : '';
  }

  applyLanguage().then(initSeriesFilter);
})();
